import { CheckCategory } from './ReleaseCheckItem'

export type RunState =
  | 'Idle'
  | 'Pending'
  | 'Running'
  | 'Completed'
  | 'Failed'
  | 'Terminated'
  | 'Canceled'
  | 'ContinuedAsNew'

export interface OrchestrationCustomStatus {
  phase: string
  totalItems: number
  completedItems: number
  currentLabel?: string | null
  startedAt?: string | null
  triggeredBy?: string | null
  category?: CheckCategory | null
}

export interface CategoryStatus {
  category: CheckCategory
  state: RunState
  customStatus?: OrchestrationCustomStatus | null
}

export interface RunStatus {
  state: RunState
  customStatus?: OrchestrationCustomStatus | null
  lastFinalizedAt?: string | null
  warnings: string[]
  // Per-category sub-orchestrator status. Keys are CheckCategory values.
  categories: Partial<Record<CheckCategory, CategoryStatus>>
  // Env tokens used in discrepancy labels (e.g. "missing in {targetEnv}").
  controlEnv: string
  targetEnv: string
}

// Sub-orchestrators currently exposed by the backend.
export const SUB_ORCHESTRATED_CATEGORIES: CheckCategory[] = [
  'KeyVault',
  'FunctionRbac',
  'DataPlaneRights',
  'VariableGroup',
  'Pipeline',
]
